import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiShoppingCart, FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import CartItem from '../components/CartItem';
import { useApp } from '../context/AppContext';

const Cart = () => {
  const { cart, cartTotal, clearCart } = useApp();
  const navigate = useNavigate();

  if (cart.length === 0) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
        <FiShoppingCart size={64} className="text-gray-300 mb-4" />
        <h2 className="text-2xl font-bold text-gray-700 mb-2">Votre panier est vide</h2>
        <p className="text-gray-500 mb-8">Ajoutez des produits pour commencer vos achats</p>
        <Link
          to="/catalogue"
          className="bg-primary text-white px-8 py-3 rounded-xl font-semibold hover:bg-blue-800 transition flex items-center gap-2"
        >
          <FiArrowLeft size={18} />
          Voir le catalogue
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-gray-800 mb-8">
        Mon <span className="text-primary">Panier</span>
      </h1>

      {/* Liste des articles */}
      <div className="space-y-4 mb-8">
        {cart.map((item, index) => (
          <CartItem key={index} item={item} />
        ))}
      </div>

      {/* Résumé */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
        <div className="flex items-center justify-between mb-4">
          <span className="text-gray-600">Sous-total</span>
          <span className="font-semibold">{cartTotal.toLocaleString()} FCFA</span>
        </div>
        <div className="flex items-center justify-between mb-4">
          <span className="text-gray-600">Livraison</span>
          <span className="text-green-600 font-semibold">Gratuite</span>
        </div>
        <div className="border-t border-gray-100 pt-4 flex items-center justify-between mb-6">
          <span className="text-gray-800 font-bold text-lg">Total</span>
          <span className="text-primary font-bold text-2xl">
            {cartTotal.toLocaleString()} FCFA
          </span>
        </div>

        <div className="flex gap-4">
          <button
            onClick={clearCart}
            className="flex-1 border-2 border-gray-200 text-gray-600 py-3 rounded-xl font-semibold hover:bg-gray-50 transition"
          >
            Vider le panier
          </button>
          <button
            onClick={() => navigate('/checkout')}
            className="flex-1 bg-primary text-white py-3 rounded-xl font-semibold hover:bg-blue-800 transition flex items-center justify-center gap-2"
          >
            Commander <FiArrowRight size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cart;